"use client";

import RichText from "@/app/shared-components/rich-text/rich-text";

interface WithdrawalFooterProps {
  termsAndConditions?: string;
  termsOfBusiness?: string;
  privacyPolicy?: string;
  cookiePolicy?: string;
  accessibility?: string;
  copyrightText?: string;
}

export default function WithdrawalFooter({
  termsAndConditions,
  termsOfBusiness,
  privacyPolicy,
  cookiePolicy,
  accessibility,
  copyrightText,
}: Readonly<WithdrawalFooterProps>) {
  const currentYear = new Date().getFullYear();
  const displayCopyright = copyrightText?.replace(
    /\d{4}/,
    currentYear.toString()
  );

  return (
    <footer
      className="bg-dark-surface-accent-1-primary"
      data-testid="withdrawal-footer"
    >
      <div className="flex flex-col md:flex-col lg:flex-row items-center md:items-start lg:items-center gap-spacing-xxl lg:gap-0 lg:justify-between pt-spacing-l pb-spacing-m px-spacing-m md:p-spacing-l">
        <nav
          className="flex flex-col md:flex-row md:justify-between items-center gap-[16px] md:gap-0 md:w-full lg:w-auto lg:gap-[16px]"
          aria-label="Footer navigation"
        >
          {termsAndConditions && (
            <RichText
              richText={termsAndConditions}
              className="font-body-font text-3xs lg:text-2xs md:whitespace-nowrap leading-6 font-semibold [&_a]:!text-surface-neutral-option-2 [&_a]:!underline [&_a]:hover:!no-underline [&_a]:!font-semibold"
              id="footer-terms-conditions"
            />
          )}
          {termsOfBusiness && (
            <RichText
              richText={termsOfBusiness}
              className="font-body-font text-3xs lg:text-2xs md:whitespace-nowrap leading-6 font-semibold [&_a]:!text-surface-neutral-option-2 [&_a]:!underline [&_a]:hover:!no-underline [&_a]:!font-semibold"
              id="footer-terms-of-business"
            />
          )}
          {privacyPolicy && (
            <RichText
              richText={privacyPolicy}
              className="font-body-font text-3xs lg:text-2xs md:whitespace-nowrap leading-6 font-semibold [&_a]:!text-surface-neutral-option-2 [&_a]:!underline [&_a]:hover:!no-underline [&_a]:!font-semibold"
              id="footer-privacy-policy"
            />
          )}
          {cookiePolicy && (
            <RichText
              richText={cookiePolicy}
              className="font-body-font text-3xs lg:text-2xs md:whitespace-nowrap leading-6 font-semibold [&_a]:!text-surface-neutral-option-2 [&_a]:!underline [&_a]:hover:!no-underline [&_a]:!font-semibold"
              id="footer-cookie-policy"
            />
          )}
          {accessibility && (
            <RichText
              richText={accessibility}
              className="font-body-font text-3xs lg:text-2xs md:whitespace-nowrap leading-6 font-semibold [&_a]:!text-surface-neutral-option-2 [&_a]:!underline [&_a]:hover:!no-underline [&_a]:!font-semibold"
              id="footer-accessibility"
            />
          )}
        </nav>

        <div className="w-full md:w-full lg:w-auto text-center md:text-center lg:text-right flex-shrink-0">
          {displayCopyright && (
            <p className="font-body-font text-2xs text-surface-neutral-option-2 md:whitespace-normal lg:whitespace-nowrap leading-6 font-normal">
              {displayCopyright}
            </p>
          )}
        </div>
      </div>
    </footer>
  );
}
